<template>
    <div>

        <b-card v-if="items">

            <div class="table-responsive">
                <table class="table table-sm b-table">
                    <thead>
                        <tr>
                            <th style="min-width: 180px">Produkt</th>
                            <th style="min-width: 120px">SKU</th>
                            <th style="min-width: 120px">Stregkode</th>
                            <th style="min-width: 100px">GTIN</th>
                            <th style="min-width: 90px" width="120">Lager</th>
                            <th style="min-width: 90px" width="120">Pris</th>
                            <th style="min-width: 90px" width="120">Rabat</th>
                            <th style="min-width: 120px">Aktiv</th>
                            <th style="min-width: 140px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(variant, key) in items" :key="'variant-' + key">
                            <td>
                                {{variant.variantName}}
                            </td>
                            <td>
                                <b-form-input v-model="variant.sku"></b-form-input>
                            </td>
                            <td>
                                <b-input-group>
                                    <b-form-input v-model="variant.gtin"></b-form-input>
                                    <b-input-group-append>
                                        <b-button variant="outline-info" size="sm" class="py-5 px-7" @click="createGtin(variant)">
                                            <feather-icon icon="PlusCircleIcon" size="16" class="" />
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </td>

                            <td>
                                <b-form-input v-model="variant.gtiN_SW"></b-form-input>
                            </td>
                            <td>
                                <b-form-input v-model="variant.stock"></b-form-input>
                            </td>
                            <td>
                                <b-form-input v-model="variant.price"></b-form-input>
                            </td>
                            <td>
                                <b-form-input v-model="variant.discount"></b-form-input>
                            </td>
                            <td>
                                <b-form-checkbox v-model="variant.inactive" class="ma-0">
                                    Ikke aktiv
                                </b-form-checkbox>
                            </td>
                            <td class="text-right">
                                <b-button variant="outline-info" class="mx-4 py-3 px-2" @click="queueLabel(variant)">
                                    <feather-icon icon="BookmarkIcon" size="16" class="mx-6 my-2" />
                                </b-button>

                                <b-button @click="saveVariant(variant)" variant="outline-success" class="mx-4 py-3 px-2">
                                    <feather-icon icon="SaveIcon" size="16" class="mx-6 my-2" />
                                </b-button>

                                <b-button :to="{ name: 'product', params: { id: variant.id } }" variant="outline-primary" class="mx-4 py-3 px-2">
                                    <feather-icon icon="Edit2Icon" size="16" class="mx-6 my-2" />
                                </b-button>

                                <b-button @click="deleteVariant(variant)" variant="outline-danger" class="mx-4 py-3 px-2">
                                    <feather-icon icon="TrashIcon" size="16" class="mx-6 my-2" />
                                </b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </b-card>

        <LabelModal ref="labelModal"></LabelModal>

    </div>
</template>

<script>
    import Toast from '@/components/_toast.vue'
    import LabelModal from './_labelModal.vue'

    export default {
        components: { LabelModal },
        data: () => ({
            loading: false
        }),
        props: {
            value: null,
        },
        computed: {
            id() {
                return this.$route.params.id
            },
            editing() {
                return this.id != "create"
            },
            items: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            }
        },
        created() {

        },
        mounted() {
        },
        methods: {
            saveVariant(variant) {
                this.$http.post("/api/products/" + this.id + "/save-variant", variant).then(x => {
                    this.$toast({
                        component: Toast,
                        props: {
                            title: x.data.result,
                            icon: 'CheckCircleIcon',
                            variant: 'success',
                        },
                    })
                })
            },
            deleteVariant(variant) {
                if (confirm("Er du sikker på at du vil slette den variant? Dette kan ikke gøres om!")) {
                    this.$http.post("/api/products/" + this.id + "/delete-variant", variant).then(x => {
                        this.getVariants()
                    })
                }
            },
            getVariants() {
                this.$http.get("/api/products/" + this.id + "/variants").then(x => {
                    this.items = x.data
                })
            },
            createGtin(variant) {
                this.$http.post("/api/products/create-gtin").then(x => {
                    variant.gtin = x.data
                })
            },
            queueLabel(variant) {
                var print = {
                    name: variant.name,
                    price: variant.price,
                    gtin: variant.gtin,
                    quantity: 1
                }

                this.$refs.labelModal.print = print
                this.$refs.labelModal.show()
            }
        },
    }
</script>